import React from "react";

type Props = {
  color?: string;
};

const CaretUpDown = ({ color = "#667085" }: Props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1542_1790"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="17"
      height="17"
    >
      <rect x="0.129883" y="0.0756836" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1542_1790)">
      <path
        d="M8.12988 14.0759L5.12988 11.0759L6.09655 10.1092L8.12988 12.1426L10.1632 10.1092L11.1299 11.0759L8.12988 14.0759ZM6.09655 6.10924L5.12988 5.14258L8.12988 2.14258L11.1299 5.14258L10.1632 6.10924L8.12988 4.07591L6.09655 6.10924Z"
        fill={color}
      />
    </g>
  </svg>
);

export default CaretUpDown;
